import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=ebe6d1f6"
import script from "./InputTextArea.vue?vue&type=script&lang=ts"
export * from "./InputTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports